import React, { useState, memo, useMemo, useCallback } from "react";
import { Link } from "react-router-dom";
import DataIteration from "../../helpers/DataIteration";
import EnquireForm from "./EnquireForm";
import { fieldDevelop, fieldCourses } from "./TabContentConfig";

const Enquire = memo(() => {
  const [tab, setTab] = useState(1);

  const tabContent = useMemo(
    () => [
      {
        id: 1,
        mapID: fieldDevelop,
        uniqKey: "__get_quotation",
        content: "Get Quotation",
      },
      // {
      //   id: 2,
      //   mapID: fieldCourses,
      //   uniqKey: "_enroll",
      //   content: "Enroll for Courses",
      // },
    ],
    [fieldDevelop, fieldCourses]
  );

  // const tabHandler = useCallback((e, value) => {
  //   e.preventDefault();
  //   // setTab(value);
  // }, []);

  const tabContentData = useMemo(() => {
    const activeTab = tabContent.find((item) => item.id === tab);
    return activeTab ? activeTab.mapID : [];
  }, [tab, tabContent]);

  return (
    <section className="Enquire-section bg-dark-blue py-60">
      <div className="container">
        <div className="row">
          <div className="col-lg-7">
            <div className="Enquire-content text-white py-100 rpt-40 rpb-100">
              <span className="sub-title d-block wow fadeInUp delay-0-2s">
                EMPOWER YOUR BUSINESS
              </span>
              <h1 className="wow fadeInUp delay-0-4s mt-20">
                Building Cutting-Edge Software for the Future
              </h1>
              <p>
                We leverage the latest technologies to craft custom software
                solutions that drive success.
              </p>
              <div className="Enquire-btn mt-35 wow fadeInUp delay-0-6s">
                 <Link to="/contact">
                  <span className="theme-btn">meet with us</span>
                </Link>
              </div>
            </div>
          </div>
          <div className="col-lg-5">
            <div className="Enquire-section-form bg-blue-tran wow fadeInRight delay-0-4s shadow-lg pb-20 rounded">
              <ul className="nav btn-group bg-purpal home-tab py-10 rounded-top">
                <DataIteration datas={tabContent} startLength={0} endLength={1}>
                  {({ datas }) => (
                    // <li key={datas.id + datas.uniqKey}>
                    //   <a
                    //     onClick={(e) => tabHandler(e, datas.id)}
                    //     className={tab === datas.id ? "active" : "disabled"}
                    //     data-toggle="tab"
                    //     href="#"
                    //   >
                    //     <h3 className="mb-0 px-25 text-white">
                    //       {datas.content}
                    //     </h3>
                    //   </a>
                    // </li>
                    <h3 className="mb-0 px-25 text-white">{datas.content}</h3>
                  )}
                </DataIteration>
              </ul>

              <div className="tab-content px-20 enquiry_mess_align">
                <DataIteration datas={tabContent} startLength={0} endLength={1}>
                  {({ datas }) => (
                    <div
                      key={datas.id + datas.uniqKey}
                      className={`tab-pane fade ${
                        tab === datas.id ? "show active" : ""
                      }`}
                      id="tabContent1"
                    >
                      <EnquireForm formElements={tabContentData} tab={tab} />
                    </div>
                  )}
                </DataIteration>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="left-circle"></div>
    </section>
  );
});

export default Enquire;
